import React from 'react';
import { Steps, Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import * as Icons from '@ant-design/icons';
const confirm = Modal.confirm;

import { graphql, compose, withApollo } from 'react-apollo';

import SelectorModelo from '../formularios/SelectorModelo';
import FormAutorizacionOtros from '../formularios/FormAutorizacionOtros';
import Generador from '../../generador/Generador';
import CKEditor from '../../editor/Example';
import Loading from '../../common/Loading';

import insertPersona from '../../../graphql/mutations/persona/insertPersona.graphql';
import insertAutorizacionOtros from '../../../graphql/mutations/tramites/insertAutorizacionOtros.graphql';
import crearAutorizacionOtro from '../../../graphql/mutations/tramites/crearAutorizacionOtro.graphql';
import confirmarAutorizacion from '../../../graphql/mutations/tramites/confirmarAutorizacion.graphql';
import obtenerNumeroTalonario from '../../../graphql/mutations/editor/obtenerNumeroTalonario.graphql';

import getDatosVenta from '../../../graphql/querys/local/getDatosVenta.graphql';
import insertDetalleVenta from '../../../graphql/mutations/venta/insertDetalleVenta.graphql';
import insertVenta from '../../../graphql/mutations/venta/insertVenta.graphql';
import BuscarYCrearPersona from '../../procesos/BuscarYCrearPersona';

import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

import { imprimir } from '../../common/funciones/imprimir';

import moment from 'moment';
import _ from 'lodash';
import { errorService } from '../../../graphql/utils/utils';
import { verPdf } from '../../common/funciones/verPdf';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@compose(
  graphql(insertAutorizacionOtros, {
    name: 'createAutorizacion',
  }),
  graphql(crearAutorizacionOtro, {
    name: 'crearAutorizacionOtro',
  }),
  graphql(confirmarAutorizacion, {
    name: 'confirmarAutorizacion',
  }),
  graphql(insertPersona, {
    name: 'createPers',
  }),
  graphql(insertDetalleVenta, {
    name: 'insertDetalleVenta',
  }),
  graphql(insertVenta, {
    name: 'insertVenta',
  }),
  graphql(getUsuario)
)
class CrearAutorizacionOtros extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      nota: {
        idModeloNota: '',
        titulo: '',
        descripcion: '',
        htmlModelo: '',
      },
      persona: {},
      autorizacion: {},
      texto_autorizacion: '',
      ente_receptor: '',
      numero: '',
      step: 0,
      guardado: false,
      confirmado: false,
      detalles: [],
      datosPosnet: {},
      extras: {},
    };

    // this.guardarPersona = this.guardarPersona.bind(this);
    this.guardarDatosAutorizacion = this.guardarDatosAutorizacion.bind(this);
    this.notaSeleccionada = this.notaSeleccionada.bind(this);
    this.siguientePaso = this.siguientePaso.bind(this);
    this.anteriorPaso = this.anteriorPaso.bind(this);

    this.finProcesoGeneracion = this.finProcesoGeneracion.bind(this);
    this.obtenerDatosGeneracion = this.obtenerDatosGeneracion.bind(this);
    this.confirmarAutorizacion = this.confirmarAutorizacion.bind(this);
    this.onImprimir = this.onImprimir.bind(this);
    this.onCancel = this.onCancel.bind(this);
    // this.buscarPersona = this.buscarPersona.bind(this);
  }

  guardarPersona = persona => {
    this.setState(
      {
        persona: {
          ...this.state.persona,
          ...persona,
        },
      },
      function() {
        this.siguientePaso();
      }
    );
  };

  guardarDatosAutorizacion(datos, ventaSinStock) {
    // console.log(datos);

    this.setState(
      {
        ...this.state,
        texto_autorizacion: datos.autorizacion,
        ente_receptor: datos.ente_receptor,
        existeVenta: datos.existeVenta,
        detalles: datos.detalles,
        datosPosnet: datos.datosPonset,
        datosMP: datos.datosMP,
        extras: datos.extras,
      },
      function() {
        this.persistirDatos(ventaSinStock);
        // this.siguientePaso();
      }
    );
  }

  notaSeleccionada(idNota) {
    this.setState({
      ...this.state,
      nota: {
        idModeloNota: idNota,
      },
    });
  }

  obtenerDatosGeneracion() {
    //Este metodo es el encargado de, dependiendo lo necesario, de generar un unico objeto que
    //Será utilizado para pasarselo al componente generador como datos de entradas.

    let textoOperacion = `Este tramite fue exento del pago de tasa de justicia - Ley N° 1971 Art. 3 -`;
    if (this.state.autorizacion && this.state.autorizacion.venta) {
      let venta = this.state.autorizacion.venta;
      textoOperacion = `Por este trámite se abono la suma de $${
        venta.importe
      } mediante el uso de ${
        venta.tipoPago
      }, en concepto de pago de tasa de justicia - Ley N° 1971 Art. 3 -`;
    }

    let datos = {
      ...this.state.persona,
      autorizacion: this.state.texto_autorizacion,
      numero: this.state.numero,
      ente_receptor: this.state.ente_receptor,
      organismo: this.props.data.getUsuario.organismo,
      textoOperacion: textoOperacion,
    };

    // console.log("los datos quedan de la siguiente manera: ");
    // console.log(datos);

    return datos;
  }

  finProcesoGeneracion(textoGenerado) {
    this.setState(
      {
        ...this.state,
        nota: {
          ...this.state.nota,
          htmlModelo: textoGenerado,
        },
      },
      function() {
        //Esta es una declaracion de una funcion sincronica, que espera a que el setState se haga para ejecutarse. Un Callback
        this.siguientePaso();
      }
    );
  }

  async onImprimir(htmlFinal) {
    const rta = await this.confirmarAutorizacion();

    if (rta || this.state.confirmado) {
      //TODO: IMPRIMIR
      // console.log("La respuesta es.....");
      // console.log(rta);
      imprimir(htmlFinal);
    }
  }

  async confirmarAutorizacion() {
    const { confirmado, autorizacion } = this.state;

    if (!confirmado) {
      try {
        const rta = await this.props.confirmarAutorizacion({
          variables: {
            _id: autorizacion._id,
            idModeloNota: this.state.nota.idModeloNota,
            numero: this.state.numero,
          },
        });
        if (rta) {
          notification.success({
            message: 'Autorizacion Confirmada!',
            description: 'Se ha confirmado con exito la Autorizacion',
          });

          this.setState({
            ...this.state,
            confirmado: true,
          });

          return rta;
        }
      } catch (err) {
        console.log('excepcion al confirmar la autorizacion');
        console.log(err);

        Modal.error({
          title: 'Error en la confirmacion de la autorizacion',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      }
    }
  }

  persistirDatos(ventaSinStock) {
    //Antes que nada, debemos verificar si ya fue guardado en la base de datos
    //Esta situacion pasaria cuando el usuario ya haya tocado el boton de imprimir antes
    //Y por alguna razon, necesita volver a imprimir (pero los datos ya fueron guardados)

    if (this.state.guardado) {
      return;
    }

    //Luego, lo primero que hacemos es, verificamos si la persona tiene id, si es asi
    // es porque vino desde el servidor, porque ya existia.
    //Entonces, no debemos crearlo.

    if (this.state.persona._id) {
      if (ventaSinStock) {
        //Esto significa que debemos generar la venta de la nueva forma.
        this.crearAutorizacionConVenta(this.state.persona._id);
      } else {
        this.crearVenta(this.state.persona._id);
      }
    }
  }

  // eslint-disable-next-line no-unused-vars
  crearAutorizacionConVenta = idPersona => {
    let yo = this;

    let modeloDetalleVenta = {
      idTipo_Sello: null,
      cantidad: null,
    };

    let { existeVenta, datosPosnet, detalles, extras, datosMP } = this.state;
    let detallesFiltrados = _.map(detalles, detalle => {
      let result = _.pick(detalle, _.keys(modeloDetalleVenta));

      return result;
    });
    let { email, enviarPorEmail, descargarRecibo } = extras;
    let venta;

    if (existeVenta && detalles.length > 0) {
      venta = {
        idVendedor: this.props.data.getUsuario._id,
        idOrganismo: this.props.data.getUsuario.organismo._id,
        detalle: detallesFiltrados,
        datosPosnet:
          (datosPosnet && (datosPosnet.codigoOperacion || datosPosnet.numeroTicket))
            ? {
                codigoOperacion: datosPosnet.codigoOperacion,
                numeroTicket: datosPosnet.numeroTicket,
                cuenta: 'Tasas',
              }
            : null,
        datosMP: datosMP
          ? { numeroComprobante: datosMP.numeroComprobante }
          : null,
        datosRecibo: {
          email,
          enviarPorEmail,
          descargarRecibo,
        },
      };
    }

    let autorizacion = {
      fecha_creacion: new Date(),
      texto_autorizacion: this.state.texto_autorizacion,
      ente_receptor: this.state.ente_receptor,
      idAutorizante: this.state.persona._id,
      idOrganismo: this.props.data.getUsuario.organismo._id,
      idCreador: this.props.data.getUsuario._id,
    };

    confirm({
      title: 'Está seguro de que desea confirmar?',
      content: 'No podrá hacer cambios sobre esta autorizacion',
      onOk: () => {
        yo.setState(
          {
            loading: true,
          },
          () =>
            this.props
              .crearAutorizacionOtro({
                variables: { autorizacion: autorizacion, venta: venta },
              })
              .then(respuestaAutorizacion => {
                if (venta) {
                  notification.success({
                    message: 'Venta registrada',
                    description: 'La venta se registro de forma exitosa',
                  });
                }
                notification.success({
                  message: 'Nueva Autorizacion',
                  description: 'Se ha registrado con exito la autorizacion',
                });

                if (
                  descargarRecibo &&
                  respuestaAutorizacion.data.crearAutorizacionOtro &&
                  respuestaAutorizacion.data.crearAutorizacionOtro.venta &&
                  respuestaAutorizacion.data.crearAutorizacionOtro.venta
                    .recibo64
                ) {
                  verPdf(
                    respuestaAutorizacion.data.crearAutorizacionOtro.venta
                      .recibo64,
                    `Recibo_Num_${
                      respuestaAutorizacion.data.crearAutorizacionOtro.venta.id
                    }`
                  );
                }

                this.setState(
                  {
                    ...this.state,
                    guardado: true,
                    pendienteCargaPersona: false,
                    loading: false,
                    autorizacion: {
                      ...respuestaAutorizacion.data.crearAutorizacionOtro,
                    },
                  },
                  () => {
                    yo.siguientePaso();
                  }
                );
              })
              .catch(error => {
                console.log('Excepcion!!');
                console.log(error);
                errorService(error, {
                  autorizacion: autorizacion,
                });
                this.setState({
                  loading: false,
                });
                Modal.error({
                  title:
                    'Error en la creacion de la autorizacion del viaje de un menor',
                  content:
                    'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
                });
              })
        );
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  // eslint-disable-next-line no-unused-vars
  crearVenta = idPersona => {
    let autorizacion;

    let modeloDetalleVenta = {
      idTipo_Sello: null,
      cantidad: null,
    };

    this.props.client
      .query({
        query: getDatosVenta,
      })
      // eslint-disable-next-line no-unused-vars
      .then(res => {
        let { existeVenta, datosPosnet, detalles } = this.state;

        let detallesFiltrados = _.map(detalles, detalle => {
          let result = _.pick(detalle, _.keys(modeloDetalleVenta));

          return result;
        });

        if (existeVenta && detalles.length > 0) {
          confirm({
            title: 'Está seguro de que desea crear la autorizacion CON VENTA?',
            content: 'No podrá hacer cambios sobre esta autorizacion',
            onOk: () => {
              this.setState(
                {
                  loading: true,
                },
                () => {
                  this.props
                    .insertDetalleVenta({
                      variables: {
                        detalleVenta: { detalle: detallesFiltrados },
                      },
                    })
                    .then(res => {
                      //El detalle de venta se inserto correctamente. Ahora debemos crear la venta..
                      let detalles = res.data.insertDetalleVenta.detalle;

                      let importe = _.sum(
                        _.map(detalles, detalle => {
                          //Esta funcion se encarga de multiplicar la cantidad de cada de talle por el valor de cada tipo_sello
                          return detalle.cantidad * detalle.tipo_sello.valor;
                        })
                      );

                      let venta = {
                        importe: importe,
                        fecha: moment().toDate(),
                        idVendedor: this.props.data.getUsuario._id,
                        idOrganismo: this.props.data.getUsuario.organismo._id,
                        idDetalle_Venta: res.data.insertDetalleVenta._id,
                        datosPosnet:
                          (datosPosnet &&
                          (datosPosnet.codigoOperacion || datosPosnet.numeroTicket))
                            ? {
                                codigoOperacion: datosPosnet.codigoOperacion,
                                numeroTicket: datosPosnet.numeroTicket,
                                cuenta: 'Tasas',
                              }
                            : null,
                      };

                      this.props
                        .insertVenta({
                          variables: { venta: venta },
                        })
                        .then(res => {
                          autorizacion = {
                            fecha_creacion: new Date(),
                            texto_autorizacion: this.state.texto_autorizacion,
                            ente_receptor: this.state.ente_receptor,
                            idAutorizante: this.state.persona._id,
                            idOrganismo: this.props.data.getUsuario.organismo
                              ._id,
                            idCreador: this.props.data.getUsuario._id,
                            idVenta: res.data.insertVenta._id,
                          };

                          this.props
                            .createAutorizacion({
                              variables: { autorizacion: autorizacion },
                            })
                            .then(respuestaAutorizacion => {
                              notification.success({
                                message: 'Venta registrada',
                                description:
                                  'La venta se registro de forma exitosa',
                              });

                              notification.success({
                                message: 'Nueva Autorizacion',
                                description:
                                  'Se ha registrado con exito la autorizacion',
                              });

                              this.setState(
                                {
                                  ...this.state,
                                  autorizacion:
                                    respuestaAutorizacion.data
                                      .insertAutorizacion,
                                  guardado: true,
                                  loading: false,
                                },
                                () => {
                                  this.siguientePaso();
                                }
                              );
                            })
                            .catch(error => {
                              console.log('Excepcion!!');
                              console.log(error);
                              this.setState({
                                loading: false,
                              });
                              errorService(error, {
                                autorizacion: autorizacion,
                              });
                              Modal.error({
                                title:
                                  'Error en la creacion de la autorizacion',
                                content:
                                  'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
                              });
                            });
                          return res;
                        })
                        .catch(err => {
                          console.log('Se ha producido un error');
                          console.log(err);
                          this.setState({
                            loading: false,
                          });
                          errorService(err, {
                            venta: venta,
                          });
                          notification.error({
                            message: 'Error al registrar la venta',
                            description:
                              'Se ha producido un error al registrar la venta',
                          });

                          return err;
                        });
                    })
                    .catch(err => {
                      console.log(
                        'Ocurrio un error a la hora de registrar el detalle de la venta'
                      );
                      console.log(err);
                      this.setState({
                        loading: false,
                      });
                      errorService(err, {
                        detalleVenta: { detalle: detallesFiltrados },
                      });

                      Modal.error({
                        title:
                          'Error en la creacion de la venta, compruebe que exista stock por favor',
                        content:
                          'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
                      });
                    });
                }
              );
            },
            onCancel() {
              console.log('Cancel');
            },
          });
        } else {
          //caso donde solo debo crear la certificacion:

          autorizacion = {
            fecha_creacion: new Date(),
            texto_autorizacion: this.state.texto_autorizacion,
            ente_receptor: this.state.ente_receptor,
            idAutorizante: this.state.persona._id,
            idOrganismo: this.props.data.getUsuario.organismo._id,
            idCreador: this.props.data.getUsuario._id,
          };

          confirm({
            title: 'Está seguro de que desea crear la autorizacion SIN VENTA?',
            content: 'No podrá hacer cambios sobre esta autorizacion',
            onOk: () => {
              this.setState(
                {
                  loading: true,
                },
                () =>
                  this.props
                    .createAutorizacion({
                      variables: { autorizacion: autorizacion },
                    })
                    .then(respuestaAutorizacion => {
                      notification.success({
                        message: 'Nueva Autorizacion',
                        description:
                          'Se ha registrado con exito la autorizacion',
                      });

                      this.setState(
                        {
                          ...this.state,
                          autorizacion:
                            respuestaAutorizacion.data.insertAutorizacion,
                          guardado: true,
                          loading: false,
                        },
                        () => {
                          this.siguientePaso();
                        }
                      );
                    })
                    .catch(error => {
                      console.log('Excepcion!!');
                      console.log(error);
                      this.setState({
                        loading: false,
                      });
                      errorService(error, {
                        autorizacion: autorizacion,
                      });

                      Modal.error({
                        title: 'Error en la creacion de la autorizacion',
                        content:
                          'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
                      });
                    })
              );
            },
            onCancel() {
              console.log('Cancel');
            },
          });
        }
      });
  };

  ModeloNotaElegido = idNota => {
    // console.log("La nota tiene el id de ....", idNota.modelo);
    // console.log("La nota tiene el id de ....", this.state.nota.idModeloNota);

    this.setState(
      {
        ...this.state,
        nota: {
          ...this.state.nota,
          idModeloNota: idNota.modelo,
        },
        loading: true,
      },
      () => {
        // console.log("Entre!");

        this.props.client
          .mutate({
            mutation: obtenerNumeroTalonario,
            variables: {
              idModeloNota: this.state.nota.idModeloNota,
            },
          })
          .then(respuesta => {
            // console.log("Recibi de respuesta....");
            // console.log(respuesta);

            if (respuesta.data.obtenerNumeroTalonario == -1) {
              notification.warning({
                message: 'Talonario no configurado',
                description:
                  'El modelo de nota no tiene configurado el talonario a usar',
              });
            }

            this.setState({
              ...this.state,
              numero: respuesta.data.obtenerNumeroTalonario
                ? respuesta.data.obtenerNumeroTalonario
                : 0,
              loading: false,
            });

            // console.log("ESTADO: ");
            // console.log(this.state);
            this.siguientePaso();
          })
          .catch(err => {
            console.log('ERROR a la hora de obtener el numero del  talonario');
            console.log(err);
          });
      }
    );
  };

  onCancel() {
    //El cancelar reinicia todo el estado de la aplicacion para volver a empezar desde 0
    this.setState({
      nota: {
        idModeloNota: '',
        titulo: '',
        descripcion: '',
        htmlModelo: '',
      },
      persona: {},
      textoDeclaracion: '',
      ente_receptor: '',
      step: 0,
    });

    this.props.history.push('/');
  }

  siguientePaso() {
    //Metodo que se encarga de aumentar en 1 el paso y es llamado por todos los metodos auxiliares
    let paso = this.state.step;
    paso++;
    this.setState({
      ...this.state,
      step: paso,
    });
  }

  anteriorPaso() {
    let paso = this.state.step;
    if (paso > 0) {
      paso--;
      this.setState({
        ...this.state,
        step: paso,
      });
    }
  }

  render() {
    const { Step } = Steps;
    let { step } = this.state;

    if (this.state.loading) {
      return <Loading />;
    }

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Autorizacion</Breadcrumb.Item>
          <Breadcrumb.Item>Otras</Breadcrumb.Item>
          <Breadcrumb.Item>Nueva</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Nueva Autorizacion
          </h2>
          <br />
          <Steps size="small" className="stepsFormularios" current={step}>
            <Step title="Buscar Persona" />
            <Step title="Autorizacion" />
            <Step title="Modelo Nota" />
            <Step title="Generacion de Nota" />
            <Step title="Editar e Imprimir" />
          </Steps>
          <div style={estiloContent}>
            {step === 0 && (
              <BuscarYCrearPersona obtenerPersona={this.guardarPersona} />
            )}

            {step === 1 && (
              <FormAutorizacionOtros
                organismo={this.props.data.getUsuario.organismo}
                onFinalizar={this.guardarDatosAutorizacion}
                onSubmit={this.guardarDatosAutorizacion}
                config={{ creacion: true }}
                datos={{
                  autorizacion: this.state.texto_autorizacion,
                  ente_receptor: this.state.ente_receptor,
                }}
              />
            )}

            {step === 2 && (
              <SelectorModelo
                handleChange={this.notaSeleccionada}
                onSubmit={this.ModeloNotaElegido}
              />
            )}
            {step === 3 && (
              <Generador
                id={this.state.nota.idModeloNota}
                // datos={this.state.persona}
                datos={this.obtenerDatosGeneracion()}
                mostrarEditor={this.finProcesoGeneracion}
              />
            )}
            {step === 4 && (
              <CKEditor
                modelo_nota={this.state.nota}
                onImprimir={this.onImprimir}
                onCancel={this.onCancel}
                onGuardar={this.confirmarAutorizacion}
                accion="visualizar"
              />
            )}
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(CrearAutorizacionOtros);
